module.exports = __webpack_public_path__ + "static/icons-db666a8c7816671c10673c767473c0dc.svg";